import { Stack, Text, Box } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Stack align="center" py={48} gap="md">
      <Box
        style={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          backgroundColor: 'var(--mantine-color-gray-1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box c="dimmed" style={{ opacity: 0.5 }}>
          {icon || <IconInbox size={48} />}
        </Box>
      </Box>
      <Text fw={600} size="xl">
        {title}
      </Text>
      {description && (
        <Text c="dimmed" size="sm" ta="center" maw={400} lh={1.5}>
          {description}
        </Text>
      )}
      {action}
    </Stack>
  );
}
